import { gql } from "@apollo/client";

import { ruleFragment } from "src/graphql/anti-fraud/fragments/RuleFragment";

export const ruleExecutionDetailsFragment = gql`
  fragment RuleExecutionDetailsFragment on RuleExecutionResult {
    id
    ruleScore
    rule {
      ...RuleFragment
    }
  }

  ${ruleFragment}
`;
